import { Navigate, Outlet } from 'react-router-dom';

import { useAuthStore } from '../stores/authStore';

const AuthRoute = () => {
  const accessToken = useAuthStore((state) => state.accessToken);
  const setIsAuthComplete = useAuthStore((state) => state.setIsAuthComplete);

  if (accessToken) {
    return <Navigate to='/' replace />;
  }

  setIsAuthComplete(true);

  return <Outlet />;
};

export { AuthRoute };
